module.exports = ".success-message {\n  margin-bottom: 3vmin; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/user/forgotPassword.component.scss
// module id = ./src/app/views/user/forgotPassword.component.scss
// module chunks = main